import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Popconfirm } from "antd";
import FormFields from "./FormFields";
import useHttp from "../../hooks/use-http";
import CONSTANTS, { PATHNAME } from "../../util/constant/CONSTANTS";
import {
  apiGenerator,
  removeEmptyArrayValues,
  removeEmptyValues,
} from "../../util/functions";
import { useLocation } from "react-router-dom";

const ModalFormCreator = ({
  open,
  onCreate,
  onCancel,
  name = "",
  formData = {},
  menu,
  disabled = false,
  edit,
  SubmitName = "Submit",
  onEdit = () => {},
  Delete,
  onDelete = () => {},
  formFields = [],
  loading = false,
  modalWidth = 700,
  children,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { pathname } = useLocation();
  const footer = {
    footer: [
      edit && (
        <Button
          key="edit"
          style={{
            borderRadius: "4px",
            height: "40px",
            width: "200px",
          }}
          ghost
          type="primary"
          onClick={onEdit}
          loading={loading}
        >
          Edit
        </Button>
      ),
      Delete && (
        <Popconfirm
          onConfirm={onDelete}
          key="deleteConfirm"
          title={`Delete ${name.toLowerCase()}`}
          description={`Are you sure to delete ${name.toLowerCase()}`}
        >
          <Button
            key="delete"
            style={{
              borderRadius: "4px",
              height: "40px",
              width: "200px",
            }}
            ghost
            type="primary"
            danger
            loading={loading}
            // onClick={onDelete}
          >
            Delete
          </Button>
        </Popconfirm>
      ),
      <Button
        key="submit"
        style={{
          // background: "#2E5BFF",
          borderRadius: "4px",
          height: "40px",
          width: "200px",
          // color: "black",
        }}
        loading={loading}
        type="primary"
        onClick={() => {
          form
            .validateFields()
            .then((values) => {
              // const removeEmpty=removeEmptyArrayValues(values)
              onCreate(values, () => {
                form.resetFields();
              });
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        {SubmitName}
      </Button>,
    ],
  };
  const [editRenderData, setEditRenderData] = useState(null);
  const api = useHttp();
  useEffect(() => {
    if (name == "Edit Blog" && open) {
      const OneBlog = { ...CONSTANTS.API.getOneBlog };
      const id = formData?.id;
      const apiOneBlog = apiGenerator(OneBlog, { id });
      api.sendRequest(apiOneBlog, (res) => {
        setEditRenderData({
          ...formData,
          description: res?.data?.description,
          overview: res?.data?.overview,
        });
        // console.log(res?.data,"*-*-*-")
      });
    }
  }, [
    (name == "Edit Blog") &&
      open &&
      formData?.id,
  ]);

  // useEffect(() => {
  // if (open) {
  //   const handleKeyPress = (e) => {
  //     if (e?.key === "Enter" && !e?.shiftKey) {
  //       form
  //         .validateFields()
  //         .then((values) => {
  //           onCreate(values, () => {
  //             form?.resetFields();
  //           });
  //         })
  //         .catch((info) => {
  //           console.log("Validate Failed:", info);
  //         });
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyPress);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyPress);
  //   };
  // }
  // }, [open]);
  return (
    <Modal
      open={open}
      title={<p className="text-2xl mb-10 text-slate-500">{name}</p>}
      okText="Submit"
      width={modalWidth ? modalWidth : 700}
      {...footer}
      cancelButtonProps={{ style: { display: "none" } }}
      className="form-modal-title"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <FormFields
        formData={editRenderData || formData}
        menu={menu}
        formFields={formFields}
        form={form}
        disabled={disabled}
        formRef={formRef}
      />
      {children}
    </Modal>
  );
};

export default ModalFormCreator;
ModalFormCreator.defaultProps = {
  open: false,
  onCreate: () => {},
  onCancel: () => {},
  name: "",
  formData: {},
  menu: "",
  edit: false,
  onEdit: () => {},
  formFields: [],
};
